import React from "react"
import "./frames.css"

const PerryEliteEMR = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">
        Perry Elite EMR: Centralizando el Registro Médico Electrónico para una
        Atención Médica Coordinada
      </h1>

      <h2 className="frames-subtitle">
        Interoperabilidad en el Sistema de Salud
      </h2>
      <p className="frames-text">
        El software Perry Elite EMR revoluciona la forma en que los hospitales y
        centros de salud gestionan y comparten los datos médicos de los
        pacientes. Utilizando una plataforma basada en la nube, este software
        avanzado centraliza los datos de tratamiento de los pacientes en una
        base de datos común. Este enfoque unificado mejora la eficiencia y
        asegura una atención médica más coordinada.
      </p>

      <h2 className="frames-subtitle">Cumplimiento de Normas y Flexibilidad</h2>
      <p className="frames-text">
        Gracias a su adopción de la norma API HL7, el software Perry Elite EMR
        se integra de manera impecable con el sistema de registro médico
        electrónico de cualquier centro de atención médica. Su diseño sencillo y
        flexible no sólo cumple con los estándares más exigentes, sino que
        también optimiza el proceso de tratamiento, haciendo que la
        administración de la atención médica sea más efectiva y menos
        complicada.
      </p>

      <h2 className="frames-subtitle">Integración con Sigma Elite</h2>
      <p className="frames-text">
        Para una mayor cohesión y eficiencia, el software Perry Elite EMR se
        puede añadir fácilmente al sistema Sigma Elite. Esta integración permite
        una comunicación fluida con el Registro Médico Electrónico (EMR) del
        centro o incluso con un sistema EMR externo, asegurando que todas las
        operaciones médicas estén sincronizadas y optimizadas.
      </p>
    </div>
  )
}

export default PerryEliteEMR
